import { ADD_PRODUCT_CATEGORY, ADD_PRODUCT_CATEGORY_ERROR, ADD_PRODUCT_CATEGORY_START, CLEAR_ERROR_PRODUCT_CATEGORY, DELETE_PRODUCT_CATEGORY, DELETE_PRODUCT_CATEGORY_ERROR, DELETE_PRODUCT_CATEGORY_START, GET_PRODUCT_CATEGORY, GET_PRODUCT_CATEGORY_ERROR, GET_PRODUCT_CATEGORY_LIST, GET_PRODUCT_CATEGORY_LIST_ERROR, GET_PRODUCT_CATEGORY_LIST_PAGEABLE, GET_PRODUCT_CATEGORY_LIST_PAGEABLE_ERROR, GET_PRODUCT_CATEGORY_LIST_PAGEABLE_START, GET_PRODUCT_CATEGORY_LIST_START, GET_PRODUCT_CATEGORY_START, UPDATE_PRODUCT_CATEGORY, UPDATE_PRODUCT_CATEGORY_ERROR, UPDATE_PRODUCT_CATEGORY_START } from '../actions/types'
import errors from './errors';

const initialState = {
    productCategoryList: [],
    productCategory: {},
    loading: false,
    error: undefined,
    totalElements: '',

}

//ADD
const addProductCategoryStart = (state) => {
    return {
        ...state,
        loading: false,
    };
};


const addProductCategory = (state, action) => {
    return {
        ...state,
        loading: false,
        productCategoryList: state.productCategoryList.concat(action.payload)
    };
};

const addProductCategoryError = (state, action) => {
    return {
        ...state,
        error: action.payload,
        loading: false,
    };
};

//UPDATE
const updateProductCategoryStart = (state) => {
    return {
        ...state,
    }
};

const updateProductCategory = (state, action) => {
    return {
        ...state,
        productCategoryList: state.productCategoryList.map((productCategory) =>
            productCategory.id === action.payload.id ?
                action.payload 
               // { ...productCategory, productCategoryName: action.payload.productCategoryName } 
               : productCategory
        ),
        loading: false,
    };
};

const updateProductCategoryError = (state, action) => {
    return {
        ...state,
        error: action.payload,
        loading: false,
    }
}

//FIND ALL

const findAllProductCategorysStart = (state) => {
    return {
        ...state,
        loading: true,
    };
};

const findAllProductCategorys = (state, ation) => {
    return {
        ...state,
        productCategoryList: action.payload,
        loading: false,
    };
};

const findAllProductCategorysError = (state, action) => {
    return {
        ...state,
        error: action.payload,
        loading: false,
    };
};


//FIND BY ID 

const findProductCategoryByIdStart = (state) => {
    return {
        ...state,
        loading: true,
    };
};

const findProductCategoryById = (state, action) => {
    return {
        ...state,
        productCategory: action.payload,
        loading: false,
    };
};

const findProductCategoryByIdError = (state, action) => {
    return {
        ...state,
        error: action.payload,
        loading: false,
    };
};


//DELETE

const deleteProductCategoryStart = (state) => {
    return {
        ...state,
        loading: true,
    };
};

const deleteProductCategory = (state, action) => {
    return {
        ...state,
        productCategoryList: state.productCategoryList.filter(
            (productCategory) => productCategory.id !== action.payload),
    };
};

const deleteProductCategoryError = (state, action) => {
    return {
        ...state,
        error: action.payload,
        loading: false,
    };
};

const clearError = (state) => {
return{
    ...state,
    error: undefined,
};
};


//PAGEABLE

const findAllProductCategoryPageableStart = (state) => {
    return {
        ...state,
        loading: true,
    };
};

const findAllProductCategoryPageableError = (state, action) => {
    return {
        ...state,
        error: action.payload,
    };
};

const findAllProductCategoryPageable = (state, action) => {
    return {
        ...state,
        productCategoryList: [...action.payload.list],
        totalElements: action.payload.totalElements,
    };
};




export default function (state = initialState, action) {
    switch (action.type) {
        case ADD_PRODUCT_CATEGORY:
            return addProductCategory(state, action);
        case ADD_PRODUCT_CATEGORY_START:
            return addProductCategoryStart(state);
        case ADD_PRODUCT_CATEGORY_ERROR:
            return addProductCategoryError(state, action);

        case UPDATE_PRODUCT_CATEGORY_START:
            return updateProductCategoryStart(state);
        case UPDATE_PRODUCT_CATEGORY:
            return updateProductCategory(state, action);
        case UPDATE_PRODUCT_CATEGORY_ERROR:
            return updateProductCategoryError(state, action);

        case GET_PRODUCT_CATEGORY_LIST_START:
            return findAllProductCategorysStart(state);
        case GET_PRODUCT_CATEGORY_LIST:
            return findAllProductCategorys(state, action);
        case GET_PRODUCT_CATEGORY_LIST_ERROR:
            return findAllProductCategorysError(state, action);

        case GET_PRODUCT_CATEGORY_START:
            return findProductCategoryByIdStart(state);
        case GET_PRODUCT_CATEGORY:
            return findProductCategoryById(state, action);
        case GET_PRODUCT_CATEGORY_ERROR:
            return findProductCategoryByIdError(state, action);

        case DELETE_PRODUCT_CATEGORY_START:
            return deleteProductCategoryStart(state);
        case DELETE_PRODUCT_CATEGORY:
            return deleteProductCategory(state, action);
        case DELETE_PRODUCT_CATEGORY_ERROR:
            return deleteProductCategoryError(state, action);
            case CLEAR_ERROR_PRODUCT_CATEGORY:
                return clearError(state);

        case GET_PRODUCT_CATEGORY_LIST_PAGEABLE_START:
            return findAllProductCategoryPageableStart(state);
        case GET_PRODUCT_CATEGORY_LIST_PAGEABLE:
            return findAllProductCategoryPageable(state, action);
        case GET_PRODUCT_CATEGORY_LIST_PAGEABLE_ERROR:
            return findAllProductCategoryPageableError(state, action);

        default:
            return state;
    }
};